import { State } from '@meraki-internal/state';
import { CommunityClient } from './CommunityClient';
import { ICareMap } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { WithLinks } from '../caremap/WithLinks';
import { CommunityModel } from './CommunityModel';
import { OrganizationsState } from '../organizations/OrganizationsState';

export class CommunityModelFactory extends State<Record<string, never>> {
    static inject = () => [
        CareMapState,
        CommunityClient,
        OrganizationsState
    ];

    constructor(
        private careMapState: CareMapState,
        public client: CommunityClient,
        public orgState: OrganizationsState
    ) {
        super({ });

        careMapState.subscribe(() => {
            const careMap = careMapState.getActiveCaremap();
            if (careMap && careMap.careMapId !== this.careMapId) {
                this.careMapId = careMap.careMapId;
                this.forActiveCaremap();
            }
        });
    };

    private careMapId?: string;
    private careMapIdToModel: { [careMapId: string]: CommunityModel } = {};

    forActiveCaremap = (): CommunityModel => {
        const activeCaremap = this.careMapState.getActiveCaremap() as WithLinks<ICareMap>;
        if (!activeCaremap) {
            // TODO: consider instead returning the most recent one
            // to avoid transition errors
            throw new Error('there is no active caremap');
        }
        if (!this.careMapIdToModel[activeCaremap.careMapId!]) {
            const model = new CommunityModel(activeCaremap, this);

            // forActiveCaremap is likely called in a render
            // so we need to avoid doing anything sync that might change state
            // or react gets upset
            setTimeout(async () => {
                await model.load();

                // if the model changes, we change, that way components can just subscrive to the factory
                model.subscribe(() => {
                    this.setState({});
                });
            });


            this.careMapIdToModel[activeCaremap.careMapId!] = model;
        }
        return this.careMapIdToModel[activeCaremap.careMapId!];
    };
}
